export default __webpack_public_path__ + "static/media/Logo_MigrationWiz Horizontal on Light.8943d69f.svg";